import { useRenderedRow } from './useRenderedPages';

/**
 * Says where a row stands, drawing nothing. It goes inside the row's drawn content: React Aria
 * renders every item's own component once to read the collection, but only the rows the
 * virtualizer draws render their content, so only those report.
 */
export function PlaceReport({
  index,
  report
}: {
  index: number;
  report: (index: number) => () => void;
}) {
  useRenderedRow(index, report);
  return null;
}
